<div class="m-content loginPage">
    <div class="row loginOuterBox">
        <div class="col-md-12">

            <div class="container loginHeader hidden-mobile-device">
                <div class="row">
                    <div class="col-6">
                        <img src="./assets/images/logos/wsfx_global_pay.webp"
                            style="height:70px; margin-top: 25px; margin-left: -120px;"
                            *ngIf="API_URL == 'https://api.wsfx.in/' " alt="Global Pay Logo">
                        <img src="./assets/images/logos/wsfx_global_pay_qa.png"
                            style="height:70px; margin-top: 25px; margin-left: -120px;"
                            *ngIf="API_URL != 'https://api.wsfx.in/' " alt="Global Pay QA Logo">
                    </div>
                    <div class="col-6">
                        <span class="pull-right">
                            <table>
                                <tr>
                                    <th><label class="btn" (click)="scroll(secAboutus)"
                                            style="color:#000; font-size: small; font-weight: bold;">About Us</label>
                                    </th>
                                    <th><label class="btn" (click)="scroll(secProducts)"
                                            style="color:#000; font-size: small; font-weight: bold;">Products</label>
                                    </th>
                                    <!-- <th><a href="#solutions" style="color:#FFF;">Solutions</a></th> -->
                                    <th><label class="btn" (click)="scroll(secAdvantage)"
                                            style="color:#000; font-size: small; font-weight: bold;">Advantage</label>
                                    </th>
                                    <th><a href="http://wsfx.in" target="_blank"
                                            style="background-color:#000 ; font-size: small; font-weight: bold;"
                                            class="m-badge m-badge--success m-badge--wide">Company Website</a></th>
                                </tr>
                            </table>
                        </span>
                    </div>
                </div>
            </div>

            <div class="container loginHeader hidden-desktop-device">
                <div class="row">
                    <div class="col-12" style="text-align:center;">
                        <img src="./assets/demo/demo2/media/img/logo/logowhite.png" style="height:60px">
                    </div>
                </div>
            </div>

        </div>

        <!-- DESKTOP LOGIN BOX -->
        <div class="col-md-12 hidden-mobile-device">
            <div class="container kontainerBody">
                <div class="kontainer">
                    <div class="kontainer-forms">
                        <div class="kontainer-info">
                            <div class="info-item">
                                <span>
                                    <h5>BE OUR</h5>
                                    <h2>Agent Partner</h2>
                                    <div>
                                        <table>
                                            <tr>
                                                <th>1.</th>
                                                <td>Enter Mobile Number and PAN</td>
                                            </tr>
                                            <tr>
                                                <th>2.</th>
                                                <td>Verify Mobile Number</td>
                                            </tr>
                                            <tr>
                                                <th>3.</th>
                                                <td>Become Partner</td>
                                            </tr>
                                        </table>
                                        <br>
                                    </div>
                                    <div class="text-center" style="width: 100%">
                                        <button id="m_register_btnregister" (click)="clearData()" style="width: 65%"
                                            class="btn btn-success btn-block m-btn m-btn--pill m-btn--custom m-btn--air">
                                            Register
                                        </button>
                                    </div>
                                </span>
                            </div>
                            <div class="info-item">
                                <span>
                                    <h5 class="blackHeading" style="padding-left: 10px;">Already a user?</h5>
                                    <div class="text-center" style="width: 100%">
                                        <button style="width: 65%"
                                            class="btn btn-success btn-block m-btn m-btn--pill m-btn--custom m-btn--air">
                                            Login
                                        </button>
                                    </div>
                                </span>
                            </div>

                        </div>
                        <div #kontainerForm class="kontainer-form">
                            <div class="form-item sign-up">
                                <div id="m_register"
                                    class="col-md-6 col-sm-12 m-register m-register--2 m-register--signup">

                                    <div class="m-register__wrapper">

                                        <div class="m-register_mobile" style="padding:15px">
                                            <form (ngSubmit)="f.form.valid && getOtpForValidation()" #f="ngForm"
                                                id="m-mobile__form" name="mobileForm" class="m-form" action="">
                                                <h5 class="whiteHeading">
                                                    1.Enter Mobile Number and PAN
                                                </h5>
                                                <div class="form-group m-form__group" style="padding-bottom:0px">
                                                    <input class="form-control m-input" type="text"
                                                        placeholder="Enter Mobile Number" name="mobile" maxlength="10"
                                                        minlength="10" [(ngModel)]="partnerMobileRequest.mobile"
                                                        #mobile="ngModel" autocomplete="off" autofocus required>
                                                </div>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input m-login__form-input--last"
                                                        type="text" oninput="this.value = this.value.toUpperCase()"
                                                        placeholder="Enter PAN" name="pan" maxlength="10" minlength="10"
                                                        pattern="[A-Z]{5}\d{4}[A-Z]{1}"
                                                        [(ngModel)]="partnerMobileRequest.pan" #pan="ngModel">
                                                </div>
                                                <div class="m-registermobile__form-action">
                                                    <button [disabled]="loading" type="submit" style="margin-right:10px"
                                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                                        id="m_register_mobile_proceed"
                                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                                        Proceed
                                                    </button>
                                                    <button [disabled]="loading" data-dismiss="alert"
                                                        (click)="mobileBack()" id="m_register_mobile_cancel"
                                                        type="clear"
                                                        class="btn btn-secondary m-btn m-btn--pill m-btn--custom">
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>

                                        <div class="m-register_otp" style="padding:15px">
                                            <h5 class="whiteHeading">
                                                2.Verify Mobile Number
                                            </h5>
                                            <div role="alert" style="color:white;">
                                                OTP has been sent to your mobile number.
                                            </div>

                                            <form (ngSubmit)="f.form.valid && validateOTP()" #f="ngForm"
                                                id="m-registerotp__form" name="otpForm" class="m-form" action="">
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="text"
                                                        placeholder="Enter OTP" maxlength="6" minlength="6" name="otp"
                                                        [(ngModel)]="partnerOtpValidateRequest.otp" #otp="ngModel"
                                                        id="m_register_otp" autocomplete="off">
                                                    <div role="alert" class="resendOTP">


                                                        <a href="javascript:;" class="m-link" (click)="resendOTP()">
                                                            <span style="color: white"><b>Resend OTP</b></span>
                                                        </a>
                                                    </div>
                                                </div>

                                                <div class="m-registermobile__form-action" style="margin-top:15px">
                                                    <button [disabled]="loading" type="submit"
                                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                                        id="m_register_otp_proceed"
                                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                                        Proceed
                                                    </button>
                                                    <button [disabled]="loading" data-dismiss="alert"
                                                        id="m_register_otp_cancel" type="clear"
                                                        class="btn btnOTPCancel m-btn m-btn--pill m-btn--custom">
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>

                                        <div class=" m-register_final_step_registration">
                                            <h5 class="whiteHeading">
                                                3.Become Partner
                                            </h5>
                                            <form (ngSubmit)="f.form.valid && onBoardPartner()" #f="ngForm"
                                                id="m-register_final_step__form" name="finalStepForm" class="m-form"
                                                action="">
                                                <h6
                                                    style="color: white;padding-bottom: 5px;text-decoration: underline;">
                                                    Your Personal Details:
                                                </h6>

                                                <div class="row" style="margin-top: -4px;">
                                                    <div class="col-md-6 col-xs-12">
                                                        <div class="form-group m-form__group">
                                                            <input class="form-control m-input"
                                                                style="padding: 10px !important;margin: 0px !important;text-transform: uppercase;"
                                                                type="text" name="pan" [(ngModel)]="partnerPan"
                                                                #pan="ngModel" autocomplete="off" disabled>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-xs-12">
                                                        <div class="form-group m-form__group">
                                                            <input class="form-control m-input"
                                                                style="padding: 10px !important;margin: 0px !important;"
                                                                type="text" name="mobile" [(ngModel)]="partnerMobile"
                                                                #mobile="ngModel" autocomplete="off" disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top: -4px;">
                                                    <div class="col-md-6 col-xs-12">
                                                        <div class="form-group m-form__group">
                                                            <input class="form-control m-input" type="text"
                                                                style="padding: 10px !important;margin: 0px !important;"
                                                                placeholder="First Name" name="firstName"
                                                                [(ngModel)]="partnerFirstName" #firstName="ngModel"
                                                                [disabled]="partnerOnBoardRequest.firstName!=null"
                                                                autocomplete="off">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-xs-12">
                                                        <div class="form-group m-form__group">
                                                            <input class="form-control m-input" type="text"
                                                                style="padding: 10px !important;margin: 0px !important;"
                                                                placeholder="Last Name" name="lastName"
                                                                [(ngModel)]="partnerLastName" #lastName="ngModel"
                                                                [disabled]="partnerOnBoardRequest.lastName!=null"
                                                                autocomplete="off">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group m-form__group"
                                                    style="padding-bottom:0px; margin-top: -15px;">
                                                    <input class="form-control m-input" type="text"
                                                        style="padding: 10px !important;margin: 0px !important;"
                                                        name="partner" [(ngModel)]="partnerName" #partner="ngModel"
                                                        placeholder="Organisation Name"
                                                        [disabled]="partnerOnBoardRequest.partnerName!=null"
                                                        autocomplete="off">
                                                </div>
                                                <div class="form-group m-form__group"
                                                    style="padding-bottom:15px; margin-top: -15px;">
                                                    <input class="form-control m-input" type="email"
                                                        style="padding: 10px !important;margin: 0px !important;"
                                                        name="email" placeholder="Enter your email"
                                                        [(ngModel)]="partnerOnBoardRequest.email" #email="ngModel"
                                                        autocomplete="off">
                                                </div>

                                                <div class="form-group m-form__group" style="margin-top: -15px;">
                                                    <select class="form-control m-input" [(ngModel)]="selectedBranch"
                                                        name="branch" #branch="ngModel" style="margin-top: -17px;">
                                                        <option value="">Select Branch</option>
                                                        <option *ngFor="let branch of branchList" [value]="branch.id">{{
                                                            branch.name }}</option>
                                                    </select>
                                                </div>

                                                <div class="m-registermobile__form-action" style="margin-top: -17px;">
                                                    <button [disabled]="loading" type="submit"
                                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                                        id="m-register_final_step_proceed"
                                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                                        Register
                                                    </button>
                                                    <button [disabled]="loading" data-dismiss="alert"
                                                        id="m_register_final_step_cancel" type="clear"
                                                        class="btn btn-secondary m-btn m-btn--pill m-btn--custom">
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <!-- ping here -->

                                </div>

                            </div>
                            <div class="form-item log-in">
                                <div id="m_login" class="col-md-6 col-sm-12 m-login m-login--1 m-login--signin">
                                    <div class="m-login__wrapper">
                                        <div class="m-login__signin">
                                            <div class="m-login__head">
                                                <h3 class="display-3 text-center"
                                                    style="font-size: 1.7rem; color: white">
                                                    Let’s Prepare For Login</h3><br>
                                                <h3 class="display-3 text-center" style="font-size: 1rem; color: white">
                                                    Getting started is quick and simple,<br> fill out the below
                                                    information.
                                                </h3>
                                            </div>
                                            <form (ngSubmit)="f.form.valid && signin()" #f="ngForm"
                                                class=" m-login__form m-form">
                                                <ng-template #alertSignin></ng-template>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="text" placeholder="Email"
                                                        name="email" [(ngModel)]="model.email" #email="ngModel"
                                                        autocomplete="off">
                                                </div>

                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input m-login__form-input--last"
                                                        type="password" placeholder="Password" name="password"
                                                        [(ngModel)]="model.password" #password="ngModel" appPassword>
                                                </div>

                                                <div class="row m-login__form-sub">
                                                    <!-- <input type="checkbox" [checked]="true" [(ngModel)]="isChecked" name="check" (click)="onCheckBoxClick()"> -->
                                                    <div class="col m-login__form-action"
                                                        style="margin-top: 0px !important;">
                                                        <button [disabled]="loading" type="submit"
                                                            [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                                            id="m_login_signin_submit"
                                                            class="btn btn-default m-btn m-btn--pill ">
                                                            Sign In
                                                        </button>
                                                    </div>

                                                    <div class="col m--align-right"
                                                        style="margin-top: 15px !important;">
                                                        <a href="javascript:;" id="m_login_forget_password"
                                                            class="m-link" (click)="fogot()">
                                                            <span style="color: white"><b>Forgot Password ?</b></span>
                                                        </a>
                                                    </div>
                                                </div>

                                            </form>
                                        </div>

                                        <div class="m-login__reset">
                                            <div class="m-login__head">
                                                <h3 class="m-login__title" style="color:#FEFEFE;">
                                                    Reset Your Password<br>
                                                </h3>
                                            </div>
                                            <!-- <div class="m-login__head">

                                            </div> -->
                                            <form (ngSubmit)="resetPassword()" #f="ngForm" class="m-login__form m-form"
                                                action="">
                                                <!-- <div class="form-group m-form__group">
                                                    <input class="form-control m-input tooltip" type="password" placeholder="Enter New Password" name="newPassword" [(ngModel)]="newPassword1"
                                                        Partner Type #newPassword="ngModel" id="newPassword1" tooltipPosition="bottom"
                                                        pInputText pTooltip="{{passwordValidation}}"
                                                        autocomplete="off" >
                                                </div>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="password" placeholder="Confirm Password" name="confirmPassword" [(ngModel)]="newPassword2"
                                                        #newPassword="ngModel" id="newPassword2" autocomplete="off" appPassword>
                                                </div> -->
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="password"
                                                        placeholder="New Password" name="newPassword"
                                                        [(ngModel)]="newPassword1" autocomplete="off"
                                                        #newPassword="ngModel" id="m_newPassword" tooltipEvent="focus"
                                                        pInputText pTooltip="{{passwordValidation}}">

                                                </div>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="password"
                                                        placeholder="Confirm Password" [(ngModel)]="newPassword2"
                                                        name="confirmPassword" id="m_confirmPassword"
                                                        autocomplete="off">
                                                </div>
                                                <div class="row form-group m-form__group m-login__form-sub">
                                                    <div class="col m--align-center">
                                                        <label class="m-checkbox m-checkbox--solid">
                                                            <input type="checkbox" [checked]="true"
                                                                [(ngModel)]="isChecked" name="check"
                                                                (click)="onCheckBoxClick()"
                                                                style="background-color:#FFFFFF;">
                                                            I Agree the
                                                            <a href="https://wsfx.in/assets/pdf/home/WSFL_Terms_Conditions.pdf"
                                                                target="_blank" class="m-link m-link--focus"
                                                                style="color:#FFF !important;">
                                                                terms and conditions.
                                                            </a>
                                                            <span></span>
                                                        </label>
                                                        <span class="m-form__help" style="float: right;"></span>
                                                    </div>
                                                </div>
                                                <div class="m-login__form-action">
                                                    <button [disabled]="!isChecked" id="m_login_reset_password_submit"
                                                        class="btn btn-secondary m-btn m-btn--pill m-btn--custom m-btn--air">
                                                        Reset
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                        <div class="m-login__forget-password">
                                            <div class="m-login__head">
                                                <h3 class="m-login__title" style="color:#FEFEFE;">
                                                    Forgot Your Password ?
                                                </h3>
                                                <div class="m-login__desc" style="color:#FEFEFE;">
                                                    Enter your email to reset your password:
                                                </div>
                                            </div>
                                            <form (ngSubmit)="f.form.valid && forgotPass()" #f="ngForm"
                                                id="m-forgot__form" name="forgetForm" class="m-login__form m-form"
                                                action="">
                                                <ng-template #alertForgotPass></ng-template>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="text" placeholder="Email"
                                                        name="email" [(ngModel)]="forgotPasswordModel.id"
                                                        #email="ngModel" id="m_email" autocomplete="off">
                                                </div>
                                                <div class="m-login__form-action">
                                                    <button [disabled]="loading" type="submit"
                                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                                        id="m_login_forget_password_submit"
                                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                                        Request
                                                    </button>
                                                    <button [disabled]="loading" data-dismiss="alert"
                                                        (click)="forgottenPasswordReset()"
                                                        id="m_login_forget_password_cancel" type="clear"
                                                        class="btn btn-secondary m-btn m-btn--pill m-btn--custom">
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                        <div class="m-login__update-password">
                                            <div class="m-login__head">
                                                <h5 class="m-login__title" style="color:#FEFEFE;font-size: 18px;">
                                                    Forgot Your Password ?
                                                </h5>
                                                <div class="m--margin-top-40 m-alert m-alert--outline m-alert--outline-2x alert alert-success fade show"
                                                    role="alert" style="display: none; color: #FEFEFE;">
                                                    OTP has been sent to your email.
                                                </div>
                                            </div>
                                            <div class="m-login__head"></div>

                                            <form (ngSubmit)="f.form.valid && updatePass()" #f="ngForm"
                                                class="m-login__form m-form" action="">
                                                <ng-template #alertForgotPass></ng-template>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="text" placeholder="OTP"
                                                        minlength="6" maxlength="6" name="verificationValue"
                                                        [(ngModel)]="updatePasswordModel.verificationValue"
                                                        #verificationValue="ngModel" id="m_otp" autocomplete="off">
                                                </div>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="password"
                                                        placeholder="New Password" name="newPassword"
                                                        [(ngModel)]="updatePasswordModel.newPassword" autocomplete="off"
                                                        #newPassword="ngModel" id="m_newPassword" tooltipEvent="focus"
                                                        pInputText pTooltip="{{passwordValidation}}">

                                                </div>
                                                <div class="form-group m-form__group">
                                                    <input class="form-control m-input" type="password"
                                                        placeholder="Confirm Password" [(ngModel)]="confirmPassword"
                                                        name="confirmPassword" id="m_confirmPassword" autocomplete="off"
                                                        (change)="valueCheck()">
                                                    <div class="form-control-feedback" *ngIf="showError">
                                                        Passwords did not match
                                                    </div>
                                                </div>
                                                <div class="m-login__form-action">
                                                    <button [disabled]="loading" type="submit"
                                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                                        id="m_login_update_password_submit"
                                                        class="btn btn-default m-btn m-btn--pill m-btn--custom m-btn--air">
                                                        Proceed
                                                    </button>
                                                    <button [disabled]="loading" data-dismiss="alert"
                                                        (click)="updatePassResetForm()"
                                                        id="m_login_update_password_cancel"
                                                        class="btn btn-danger m-btn m-btn--pill m-btn--custom">
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- DESKTOP LOGIN BOX -->

        <!-- MOBILE LOGIN BOX -->
        <div class="col-md-12 hidden-desktop-device">
            <div class="mobile-view">

                <div class="container mobile-custom-container mobile-view-home">
                    <div class="info-item">
                        <span>
                            <h5>BE OUR</h5>
                            <h2>Agent Partner</h2>
                            <div>
                                <table>
                                    <tr>
                                        <th>1.</th>
                                        <td>Enter Mobile Number and PAN</td>
                                    </tr>
                                    <tr>
                                        <th>2.</th>
                                        <td>Verify Mobile Number</td>
                                    </tr>
                                    <tr>
                                        <th>3.</th>
                                        <td>Become Partner</td>
                                    </tr>
                                </table>
                                <br>
                            </div>
                            <div class="text-center" style="width: 100%;">

                                <table style="width: 100%;">
                                    <tr>
                                        <td style="width:50%; text-align: center;">
                                            <button id="m_register_btnregister" (click)="clearData()" style="width:90%;"
                                                class="btn btn-success btn-block m-btn m-btn--pill m-btn--custom m-btn--air">
                                                Register
                                            </button>
                                        </td>
                                        <td style="width:50%;text-align: center;">
                                            <button id="m_register_btnregister" (click)="clearData()" style="width:90%;"
                                                class="btn btn-success btn-block m-btn m-btn--pill m-btn--custom m-btn--air">
                                                Login
                                            </button>
                                        </td>
                                    </tr>
                                </table>


                            </div>
                        </span>
                    </div>
                </div>

                <div class="container mobile-custom-container-login  mobile-view-login">
                    <div class="info-item">
                        <div class="m-login__signin">
                            <div class="m-login__head">
                                <h3 class="display-3 text-center" style="font-size: 1.7rem; color: white">
                                    Let’s Prepare For Login</h3><br>
                                <h3 class="display-3 text-center" style="font-size: 1rem; color: white">
                                    Getting started is quick and simple,<br> fill out the below information.
                                </h3>
                            </div>
                            <form (ngSubmit)="f.form.valid && signin()" #f="ngForm" class=" m-login__form m-form">
                                <ng-template #alertSignin></ng-template>
                                <div class="form-group m-form__group">
                                    <input class="form-control m-input" type="text" placeholder="Email" name="email"
                                        [(ngModel)]="model.email" #email="ngModel" autocomplete="off">
                                </div>

                                <div class="form-group m-form__group">
                                    <input class="form-control m-input m-login__form-input--last" type="password"
                                        placeholder="Password" name="password" [(ngModel)]="model.password"
                                        #password="ngModel" appPassword>
                                </div>

                                <div class="row m-login__form-sub">
                                    <div class="col m-login__form-action" style="margin-top: 0px !important;">
                                        <button [disabled]="loading" type="submit"
                                            [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                            id="m_login_signin_submit2" class="btn btn-default m-btn m-btn--pill ">
                                            Sign In
                                        </button>
                                    </div>

                                    <div class="col m--align-right" style="margin-top: 15px !important;">
                                        <a href="javascript:;" id="m_login_forget_password" class="m-link"
                                            (click)="fogot()">
                                            <span style="color: white"><b>Forgot Password ?</b></span>
                                        </a>
                                    </div>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>

                <div class="container mobile-custom-container-login  mobile-view-signup"
                    style="border-top:1px solid #eee;">
                    <div class="m-register__wrapper">

                        <div class="m-register_mobile2" style="padding:15px">
                            <form (ngSubmit)="f.form.valid && getOtpForValidation()" #f="ngForm" id="m-mobile__form2"
                                name="mobileForm" class="m-form" action="">
                                <h5 class="whiteHeading">
                                    1.Enter Mobile Number and PAN
                                </h5>
                                <div class="form-group m-form__group" style="padding-bottom:0px">
                                    <input class="form-control m-input" type="text" placeholder="Enter Mobile Number"
                                        name="mobile" maxlength="10" minlength="10"
                                        [(ngModel)]="partnerMobileRequest.mobile" #mobile="ngModel" autocomplete="off"
                                        autofocus required>
                                </div>
                                <div class="form-group m-form__group">
                                    <input class="form-control m-input m-login__form-input--last"
                                        placeholder="Enter PAN" name="pan" maxlength="10" minlength="10"
                                        pattern="[A-Za-z]{5}\d{4}[A-Za-z]{1}" [(ngModel)]="partnerMobileRequest.pan"
                                        #pan="ngModel">
                                </div>
                                <div class="m-registermobile__form-action">
                                    <button [disabled]="loading" type="submit" style="margin-right:10px"
                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                        id="m_register_mobile_proceed2"
                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                        Proceed
                                    </button>
                                    <button [disabled]="loading" data-dismiss="alert" (click)="mobileBack()"
                                        id="m_register_mobile_cancel2" type="clear"
                                        class="btn btn-secondary m-btn m-btn--pill m-btn--custom">
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div class="m-register_otp2" style="padding:15px">
                            <h5 class="whiteHeading">
                                2.Verify Mobile Number
                            </h5>
                            <div role="alert" style="color:#fff;">
                                OTP has been sent to your mobile number.
                            </div>
                            <form (ngSubmit)="f.form.valid && validateOTP()" #f="ngForm" id="m-registerotp__form2"
                                name="otpForm" class="m-form" action="">
                                <div class="form-group m-form__group">
                                    <input class="form-control m-input" type="text" placeholder="Enter OTP"
                                        maxlength="6" minlength="6" name="otp"
                                        [(ngModel)]="partnerOtpValidateRequest.otp" #otp="ngModel" id="m_register_otp2"
                                        autocomplete="off">
                                </div>

                                <div class="m-registermobile__form-action">
                                    <button [disabled]="loading" type="submit"
                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                        id="m_register_otp_proceed2"
                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                        Proceed
                                    </button>
                                    <button [disabled]="loading" data-dismiss="alert" id="m_register_otp_cancel2"
                                        type="clear" class="btn btnOTPCancel m-btn m-btn--pill m-btn--custom">
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div class=" m-register_final_step_registration2" style="padding:15px">
                            <h5 class="whiteHeading">
                                3.Become Partner
                            </h5>
                            <form (ngSubmit)="f.form.valid && onBoardPartner()" #f="ngForm"
                                id="m-register_final_step__form2" name="finalStepForm" class="m-form" action="">
                                <h6 style="color: white;padding-bottom: 5px;text-decoration: underline;">
                                    Your Personal Details:
                                </h6>

                                <div class="row">
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group m-form__group">
                                            <input class="form-control m-input"
                                                style="padding: 10px !important;margin: 0px !important;text-transform: uppercase;"
                                                type="text" name="pan" [(ngModel)]="partnerPan" #pan="ngModel"
                                                autocomplete="off" disabled>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group m-form__group">
                                            <input class="form-control m-input"
                                                style="padding: 10px !important;margin: 0px !important;" type="text"
                                                name="mobile" [(ngModel)]="partnerMobile" #mobile="ngModel"
                                                autocomplete="off" disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" style="padding-top:15px">
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group m-form__group">
                                            <input class="form-control m-input" type="text"
                                                style="padding: 10px !important;margin: 0px !important;"
                                                placeholder="First Name" name="firstName" [(ngModel)]="partnerFirstName"
                                                #firstName="ngModel" [disabled]="partnerOnBoardRequest.firstName!=null"
                                                autocomplete="off">
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group m-form__group">
                                            <input class="form-control m-input" type="text"
                                                style="padding: 10px !important;margin: 0px !important;"
                                                placeholder="Last Name" name="lastName" [(ngModel)]="partnerLastName"
                                                #lastName="ngModel" [disabled]="partnerOnBoardRequest.lastName!=null"
                                                autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group m-form__group" style="padding-bottom:0px;">
                                    <input class="form-control m-input" type="text"
                                        style="padding: 10px !important;margin: 0px !important;" name="partner"
                                        [(ngModel)]="partnerName" #partner="ngModel" placeholder="Organisation Name"
                                        [disabled]="partnerOnBoardRequest.partnerName!=null" autocomplete="off">
                                </div>
                                <div class="form-group m-form__group" style="padding-bottom:15px;">
                                    <input class="form-control m-input" type="email"
                                        style="padding: 10px !important;margin: 0px !important;" name="email"
                                        placeholder="Enter your email" [(ngModel)]="partnerOnBoardRequest.email"
                                        #email="ngModel" autocomplete="off">
                                </div>

                                <div class="m-registermobile__form-action">
                                    <button [disabled]="loading" type="submit"
                                        [ngClass]="{'m-loader m-loader--right m-loader--light': loading}"
                                        id="m-register_final_step_proceed2"
                                        class="btn btn-warning m-btn m-btn--pill m-btn--custom m-btn--air">
                                        Register
                                    </button>
                                    <button [disabled]="loading" data-dismiss="alert" id="m_register_final_step_cancel2"
                                        type="clear" class="btn btn-secondary m-btn m-btn--pill m-btn--custom">
                                        Cancel
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- MOBILE LOGIN BOX -->

    </div>

    <div class="row aboutus" id='aboutUs' #secAboutus>
        <div class="col-md-12">
            <div class="container">
                <h2 class="text-center">About Us</h2>
                <p class="text-center">WSFx Global Pay Ltd. is a RBI licensed Authorised Dealer Category II foreign
                    exchange house
                    listed in BSE with a network of 16 branches across India to cater to the foreign exchange needs of
                    the
                    International Traveller. </p>
                <p class="text-center">Over the past 30 years WSFx has emerged as a vibrant and trusted brand and is
                    widely recognised in the field
                    of Foreign Exchange. The company’s vision is to transform into an Omni Channel Forex Services
                    Provider
                    and provide a range of Digital Solutions for Corporates, B2B & B2C in the Forex and Outward
                    remittance
                    space.
                </p>
            </div>
        </div>
    </div>

    <div class="row products" id="products" #secProducts>
        <div class="col-md-12">
            <div class="container">
                <h2 class="text-center">Our Products</h2><br><br>
                <div class="row">
                    <div class="col-md-4 text-center">
                        <img src="./assets/demo/demo2/media/img/icons/products/1.png" style="height:60px"><br><br>
                        <b>Outward Remittance</b><br><br> Send money abroad with ease and convenience.
                    </div>
                    <div class="col-md-4 text-center">
                        <img src="./assets/demo/demo2/media/img/icons/products/2.png" style="height:60px"><br><br>
                        <b>Forex Prepaid Cards</b><br><br> Travel Smart...Travel Light. When you move across the globe,
                        power
                        yourself with the convenience of our digitally enabled, reloadable Multi Currency Forex Cards.
                    </div>
                    <div class="col-md-4 text-center">
                        <img src="./assets/demo/demo2/media/img/icons/products/3.png" style="height:60px"><br><br>
                        <b>Currency Notes</b><br><br> Buying and selling of all International Currencies.
                    </div>
                    <div class="col-md-12"><br><br><br><br></div>

                    <div class="col-md-2 text-center"></div>
                    <div class="col-md-4 text-center">
                        <img src="./assets/demo/demo2/media/img/icons/products/4.png" style="height:60px"><br><br>
                        <b>Travel Insurance</b><br><br>Wherever you are travelling around the world, we make sure you
                        are
                        covered at every step.
                    </div>
                    <div class="col-md-4 text-center">
                        <img src="./assets/demo/demo2/media/img/icons/products/5.png" style="height:60px"><br><br>
                        <b>Receive Money</b><br><br>Carrying limited cash comes in handy for your miscellaneous /
                        immediate
                        expenses.
                    </div>
                    <div class="col-md-2 text-center"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="row partners">
        <div class="col-md-12">
            <div class="container">
                <h2 class="text-center">Our Partners</h2><br><br>
                <div class=" row text-center">
                    <div class="col-md-3 text-center">
                        <img src="../../../assets/demo/demo2/media/img/icons/yesBankLogo.png" style="width: 50%">
                    </div>

                    <div class="col-md-3 text-center">
                        <img src="../../../assets/demo/demo2/media/img/icons/banking2.png" style="width: 70%">
                    </div>

                    <div class="col-md-3 text-center">
                        <img src="../../../assets/demo/demo2/media/img/icons/banking3.png" style="width: 55%">
                    </div>

                    <div class="col-md-3 text-center">
                        <img src="../../../assets/demo/demo2/media/img/icons/banking4.png" style="width: 55%">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row features" id='advantage' #secAdvantage>
        <div class="col-md-12">
            <div class="container">
                <h2 class="text-center">Awesome Features</h2><br><br>
                <div class="row">
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/1.png" style="height:25px">
                            <b style="color: #acacac;">Lifetime value</b>
                        </div>
                        <div>
                            The portal is a comprehensive solution for the agents to manage their transactions
                            end-to-end starting from lead booking
                            to tracking the status to generating the invoice / SWIFT copy for the customer if required.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/2.png" style="height:25px">
                            <b style="color:#acacac">Live exchange rate based order booking</b>
                        </div>
                        <div>
                            The portal is updated with the latest exchange rates at product level enabling easy
                            management of orders and bookings
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/3.png" style="height:25px">
                            <b style="color:#acacac">Real time transaction status</b>
                        </div>
                        <div>
                            The status of the order placed changes according to various scenarios i.e KYC update,
                            Documents Upload, compliance check
                            etc., by which the agent gets notified about his order being completed & executed
                        </div>
                    </div>
                    <div class="col-md-12"><br></div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/4.png" style="height:25px">
                            <b style="color:#acacac">Offering all foreign exchange products </b>
                        </div>
                        <div>
                            The portal offers all foreign exchange products namely currency notes, Forex Prepaid cards,
                            Remittances and travel insurance
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/5.png" style="height:25px">
                            <b style="color:#acacac">Transparency and trust achieved</b>
                        </div>
                        <div>
                            The system has Live Exchange rates prevailing at that very moment and hence complete
                            transparency is provided to the agent
                            and the consumer
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/6.png" style="height:25px">
                            <b style="color:#acacac">Multiple location access, dashboard and MIS</b>
                        </div>
                        <div>
                            The portal provides access to various branch locations of the agent, where the agent can
                            view the transactions of his respective
                            branches
                        </div>
                    </div>
                    <div class="col-md-12"><br></div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/7.png" style="height:25px">
                            <b style="color:#acacac">Forex Order workflow management</b>
                        </div>
                        <div>
                            The portal has a detailed workflow, both for the agent as well as for the branch to process
                            and track the transaction
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/8.png" style="height:25px">
                            <b style="color:#acacac">Forex lead management</b>
                        </div>
                        <div>
                            WSFX agent portal enables our agent partner’s to login in the portal and add a lead / order
                            directly without requiring them
                            to call / email and wait for an offline process.
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <img src="./assets/demo/demo2/media/img/icons/awsomefeatures/9.png" style="height:25px">
                            <b style="color:#acacac">Access to “Invoice” and “Swift copy”</b>
                        </div>
                        <div>
                            The Portal provides various other information including invoice / SWIFT copy which can be
                            downloaded and provided to the
                            end customer across the counter.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row testimonials">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="testimonialsText">
                        Thank you for the excellent service provided to my company. We have been using your services for
                        4 years now and not seen
                        any delay in any payment from your end. Since we are satisfied with your all services and prompt
                        reply on our each query, definitely I would not hesitate to recommend you to others.
                    </div>
                    <div>
                        <table>
                            <tr>
                                <!-- <td>
                                    <img src="./assets/demo/demo2/media/img/icons/avatar.png" style="height:60px">
                                </td> -->
                                <td style="color:white">
                                    <b>- Arjun Rawat,</b> Dnata
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="testimonialsText">
                        Our business partnership will shortly enter in its third year and we would like to extend our
                        heartfelt thanks for your support
                        in our business. We greatly appreciate your efficiency in providing the best rates & support,
                        and
                        the extra mila you guys take to deliver currencies and TTs.
                        <br> We hope you will continue your exceptional service in the coming years as well. We look
                        forward
                        for a long association with you.
                    </div>
                    <div>
                        <table>
                            <tr>
                                <!-- <td>
                                <img src="./assets/demo/demo2/media/img/icons/avatar.png" style="height:60px">
                            </td> -->
                                <td style="color:white">
                                    <b>- Singaravelou,</b> Mapp Your Tours
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="row techsupport">
        <div class="col-md-12">
            <div class="container">
                <br>
                <div class="text-center">
                    <img src="./assets/demo/demo2/media/img/techsupport.jpg" style="width: 100%">
                </div>
            </div>
        </div>
    </div>

    <footer class="footer footer-black footer-big" style="background: #525252;">
        <div class="container-fluid">
            <div class="row bgcolor">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <h5 style="color:#FFFFFF;font-weight: 600;">Agent Forex Solutions</h5><br>
                            <p>
                                WSFX agent portal enables our agent partner’s to login in the portal and add a lead /
                                order directly without requiring them
                                to call / email and wait for an offline process. The portal is updated with the latest
                                exchange
                                rates at product level and provides various other information including invoice / SWIFT
                                copy
                                which can be downloaded and provided to the end customer across the counter in a jiffy.
                                <br><br>
                            </p>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-12">
                            <h5 style="color:#FFFFFF;font-weight: 600;">Products</h5>
                            <ul style="padding: 0px;">
                                <li><a href="https://www.wsfx.in/travel-insurance" target="_blank">Travel Insurance</a>
                                </li>
                                <li><a href="https://www.wsfx.in/forex-prepaid-cards" target="_blank">Forex Prepaid
                                        Cards</a></li>
                                <li><a href="https://www.wsfx.in/outward-remittance" target="_blank">Outward
                                        Remittances</a></li>
                                <!-- <li><a href="javascript:void(0)">Foreign Exchange</a></li> -->
                                <li><a href="https://www.wsfx.in/currency-notes" target="_blank">Currency Notes</a></li>
                                <li><a href="https://www.wsfx.in/international-student-identity-card"
                                        target="_blank">International Student Identity Card (ISIC)</a></li>
                                <!-- <li><a href="https://wsfx.in/products/foreign-exchange/Travellers" target="_blank">Travellers Cheque</a></li> -->
                            </ul>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <h5 style="color:#FFFFFF;font-weight: 600;">Contact Us</h5>
                            <ul style="padding: 0px;">
                                <li>
                                    <span>
                                        <b>WSFx Global Pay Ltd.</b><br>
                                        <!-- 113-122, 01<sup>st</sup> Floor, "A"- Wing,<br>
                                        Chintamani Plaza,
                                        Andheri Kurla Road, Chakala<br>
                                        Andheri (East), Mumbai - 400 099.<br>
                                        Wall Street Finance Limited -->
                                        Unit No. 603, 6<sup>th</sup> Floor, Wing C,
                                        Corporate Avenue, New AK Link Road,
                                        Chakala, Opp. Solitaire Corporate Park,
                                        Andheri (East), Mumbai - 400093.
                                    </span>
                                    <br><br>
                                </li>
                                <li>
                                    <span>
                                        <i class="fa fa-envelope-open-o"></i>
                                        <a href="mailto:info@wsfx.in" class="black-text">info@wsfx.in</a>
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i class="fa fa-phone"></i>
                                        8976707222
                                    </span>
                                </li>
                                <!--
                                <li>
                                    <span>
                                    <i class="fa fa-comments-o" aria-hidden="true"></i>
                                        FOREX "YOUR REQUIREMENT"<br>
                                        and SEND TO 542423
                                    </span>
                                </li>
                                -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row sort-footer" style="font-weight:600; background: #000;">
                <div class="copyright">
                    CIN L99999MH1986PLC039660<br> © {{footerYear | date: 'yyyy'}} WSFx Global Pay Ltd. Limited. All
                    Rights
                    Reserved | <a (click)="showDisclaimer()" style="color:#FFF;cursor: pointer;">Disclaimer</a> |
                    <span><a href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/pdf/home/WSFL_Terms_Conditions.pdf"
                            target="_blank" style="color:#FFF;">Terms & Conditions</a></span>
                    | <span><a href="https://files.wsfx.in/pdf/home/WSFX_Customer_Grievance_Redressal_Policy_v1.pdf"
                            target="_blank" rel="noopener" style="color:#FFF;">Grievances Policy</a></span>
                </div>
            </div>
        </div>
    </footer>

</div>


// WEBPACK FOOTER //
// ./src/app/auth/templates/login-2.component.html